<div class="coupon-form-box" role="region" [attr.aria-label]="'Coupon code form'">
  <form
    #couponForm="ngForm"
    class="coupon-form mb-0"
    role="form"
    [attr.aria-label]="'Apply coupon code'"
    [attr.aria-describedby]="'coupon-instructions'"
  >
    <div id="coupon-instructions" class="visually-hidden" role="status">
      Enter your coupon code to apply a discount to your booking
    </div>
    <div>
      <div class="input-group">
        <label for="coupon" class="visually-hidden">Coupon code</label>
        <input
          type="text"
          class="form-control"
          placeholder="{{ (bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_COUPON_PLACEHOLDER, type: 'template' }) | translation: 'template_content': lang }}"
          [(ngModel)]="coupon"
          name="coupon"
          #couponModel="ngModel"
          id="coupon"
          [attr.aria-invalid]="showError"
          [attr.aria-describedby]="showError ? 'coupon-errors' : (showSuccessMsg ? 'coupon-success' : null)"
        />
        <button
          [disabled]="!coupon"
          type="submit"
          class="btn btn-secondary redeem-button"
          (click)="onApplyCoupon()"
          role="button"
          [attr.aria-label]="'Apply coupon code'"
          [attr.aria-disabled]="!coupon"
        >
          {{ (bookingService.widgetTemplates | calioMeetingTemplate: { id: templateConstant.WIDGET_COUPON_REDEEM_TEXT, type: 'template' }) | translation: 'template_content': lang }}
        </button>
      </div>
      @if (showError) {
        <div
          id="coupon-errors"
          class="coupon-errors col-md-12 mt-1"
          role="alert"
          [attr.aria-live]="'polite'"
        >
          {{ "coupon_credit_card_info.invalid_coupon" | translate }}
        </div>
      }
      @if (showEmailRequiredError) {
        <div id="coupon-errors" class="coupon-errors col-md-12 mt-1" role="alert">
          {{ 'coupon_credit_card_info.coupon_email_required_error' | translate }}
        </div>
      }
      @if (showInsufficientBalanceError) {
        <div id="coupon-errors" class="coupon-errors col-md-12 mt-1" role="alert">
          {{ "coupon_credit_card_info.insufficient_balance_error" | translate }}
        </div>
      }
      @if (showSuccessMsg) {
        @if (showRemainingBalanceNote) {
          <div id="coupon-success" class="coupon-success col-md-12 mt-1" role="alert" [attr.aria-live]="'polite'">
            {{ 'coupon_credit_card_info.coupon_applied_remaining_balance' | translate : { currency: bookingService?.partnerData?.currency, amount: remainingBalance } }}
          </div>
        } @else {
          <div id="coupon-success" class="coupon-success col-md-12 mt-1" role="alert" [attr.aria-live]="'polite'">
            {{ 'coupon_credit_card_info.applied_successfully' | translate }}
          </div>
        }
      }
    </div>
  </form>
</div>
